import { defineStore } from "pinia";

import type {
    IPlannedCurriculumsState,
    ICurriculumDto,
    IPlannedCurriculumDto,
} from "@/shared/libs/stores/server/planned-curriculums/interface";

const usePlannedCurriculumsStore = defineStore("plannedCurriculumsStore", {
    state: (): IPlannedCurriculumsState => ({
        curriculumDtos: null,
        plannedCurriculum: null,
    }),
    actions: {
        setCurriculumDtos(curriculumDtos: ICurriculumDto[]) {
            this.curriculumDtos = curriculumDtos;
        },
        setPlannedCurriculum(plannedCurriculum: IPlannedCurriculumDto[]) {
            this.plannedCurriculum = plannedCurriculum;
        },
    },
    persist: true,
});

export default usePlannedCurriculumsStore;
